import { useObjectState } from '../State/useObjectState';
import type { ProcessControlCore } from './useProcessControl.types';

export const useProcessControl = <
	T extends ProcessControlCore = ProcessControlCore,
>(
	props: Partial<T> = {}
) => {
	const [controls, setControls] = useObjectState<T>({
		initialError: null,
		processError: null,
		initialLoading: true,
		processLoading: false,
		...props,
	} as T);

	return { controls, setControls };
};
